import React, { useState, useEffect, useCallback } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import NavItem from "./NavItem";
import { navItems } from "./navConfig"; // <-- IMPORT from the new config file

const SidebarNav = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // The navItems array is now imported from navConfig.js

  const getActiveItem = useCallback((pathname) => {
    // This logic is now simpler because we can refer to the imported navItems
    let currentItem = navItems.find(
      (item) => item.id !== "profile" && pathname.startsWith(item.path)
    );
    if (!currentItem && pathname === "/profile-setup") {
      currentItem = navItems.find((item) => item.id === "profile");
    }
    return currentItem ? currentItem.id : null;
  }, []); // navItems is not a dependency as it's a static import

  const [activeItem, setActiveItem] = useState(() =>
    getActiveItem(location.pathname)
  );

  useEffect(() => {
    setActiveItem(getActiveItem(location.pathname));
  }, [location.pathname, getActiveItem]);

  const handleNavClick = (item) => {
    navigate(item.path);
  };

  return (
    <nav className="smai-sidebar-nav">
      <ul className="smai-nav-list">
        {navItems.map((item) => (
          <NavItem
            key={item.id}
            icon={item.icon}
            label={item.label}
            active={activeItem === item.id}
            onClick={() => handleNavClick(item)}
          />
        ))}
      </ul>
    </nav>
  );
};

export default SidebarNav;
